import { render, staticRenderFns } from "./SuburbReport.vue?vue&type=template&id=472d8839&scoped=true&"
import script from "./SuburbReport.vue?vue&type=script&lang=ts&"
export * from "./SuburbReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d8839",
  null
  
)

export default component.exports